import {loadingWindowVisible, loadingWindowHidden} from '4-component/loading/_index.js'
import ajaxRequest from 'utils/_ajax-request.js'
import {confirmBlockToggle} from 'utils/_confirm.js'

let rowElement = undefined

// export
const deleteBtnHandler = (event) => {
  confirmBlockToggle('show')
  rowElement = event.target.closest('.user-list__body-item')
  return false
}


const deleteAction = () => {
  const confirmYes = document.querySelector('.confirm__block .user-confirm-button-yes')
  if( confirmYes ) {
    confirmYes.addEventListener('click', (event) => {
      event.preventDefault()

      confirmBlockToggle('hide')

      loadingWindowVisible('process', '.page__content')

      document.querySelector('.loading__error-text').innerHTML = ''

      let openUrl = '/{!_locale}/admin/users/{!id}/delete'

      if (rowElement && rowElement.dataset.id) {
        ajaxRequest(
          (xhr, error) => {
            loadingWindowHidden('process', '.page__content')

            if( error ) {
              loadingWindowVisible('error', '.page__content')
            }

            const data = JSON.parse(xhr.response)

            if( data['status'] == 1 ) {
              loadingWindowVisible('success', '.page__content')
              document.querySelector('.user-list__body-item[data-id="' + data['id'] + '"]').remove()
            }
            else {
              loadingWindowVisible('error', '.page__content')

              if( data.hasOwnProperty('is_admin') ) {
                document.querySelector('.loading__error-text').innerHTML = 'Пользователь явялется администратором.'
              }
            }

          },
          (openUrl+'?ajax=1')
            .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
            .replaceAll('{!id}', rowElement.dataset.id)
        )
      } else {
        loadingWindowHidden('process', '.page__content')
        loadingWindowVisible('error', '.page__content')
      }

    })
  }

  const confirmNo = document.querySelector('.confirm__block .user-confirm-button-no')
  if( confirmNo ) {
    confirmNo.addEventListener('click', (event) => {
      event.preventDefault()
      confirmBlockToggle('hide')
    })
  }
}


export {
  deleteBtnHandler,
  deleteAction,
}


